// extracted by mini-css-extract-plugin
module.exports = {"colorAlert_root":"styles_colorAlert_root__34zXF","colorAlert_title":"styles_colorAlert_title__1hPvE","colorAlert_actionButton":"styles_colorAlert_actionButton__o5Xvo"};